export async function waiting (ms: number): Promise<void> {
  await new Promise((resolve) => setTimeout(resolve, ms))
}
